<div #streamContainer class="device-stream" [class._responsive]="responsive" (fullscreenchange)="checkIsFullscreen()">
  <div class="device-stream__header">
    <div class="device-stream__title" [title]="{ name: deviceName, deviceId: deviceId } | deviceName">
      {{ { name: deviceName, deviceId: deviceId } | deviceName }}
    </div>
    @if (uploading()) {
      <mat-progress-spinner diameter="24" mode="indeterminate" />
    }
    <div class="device-stream__header-actions">
      @if (isFullscreenSupported) {
        <button class="_close" app-icon-button type="button" (click)="toggleFullscreen(streamContainer)">
          <mat-icon svgIcon="fullscreen" />
        </button>
        <button class="_close" app-icon-button type="button" (click)="closeClicked.emit()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
  <div class="device-stream-video">
    <div #videoContainer class="device-stream-video__inner">
      @if ($loading()) {
        <div class="device-stream-overlay _loader">
          <mat-progress-spinner diameter="40" mode="indeterminate" />
        </div>
      }

      @if (error()) {
        <div class="device-stream-overlay _error">
          <span>Ошибка</span>
        </div>
      }

      @if (recordActive()) {
        <div class="device-stream-video-indicator">
          <div class="device-stream-video-indicator__icon"></div>
          <div>{{ recordTimeLabel() }}</div>
        </div>
      }

      <video #videoEl autoplay [playsInline]="true" muted [style.transform]="rotationTransform()"></video>
      <audio #audioEl autoplay [muted]="muted" [volume]="volume()" (volumechange)="volume.set(audioEl.volume)"></audio>
      @if (showControls()) {
        <div
          #controls
          class="device-stream-controls"
          (mouseenter)="handleControlsMouseenter()"
          (mouseleave)="handleControlsMouseleave()"
        >
          <div class="device-stream-audio-control">
            <button app-icon-button (click)="muted = !muted">
              @if (muted) {
                <mat-icon> volume_off </mat-icon>
              } @else {
                <mat-icon> volume_up </mat-icon>
              }
            </button>
            @if (controls.clientWidth > 200) {
              <div
                #volumeSliderEl
                class="device-stream-audio-slider"
                [class._muted]="muted"
                [style.--volume]="volumePercentStyle()"
                (mousedown)="handleVolumeSliderClick(volumeSliderEl, $event)"
                (keydown)="$event.preventDefault()"
                tabindex="0"
              >
                <div class="device-stream-audio-slider__track">
                  <div class="device-stream-audio-slider__thumb"></div>
                </div>
              </div>
            }
          </div>

          <div class="device-stream-record">
            <button app-icon-button (click)="rotate()">
              <mat-icon>screen_rotation</mat-icon>
            </button>
            <button app-icon-button (click)="screenshot()">
              <mat-icon>photo_camera</mat-icon>
            </button>
            @if (recordActive()) {
              <button app-icon-button color="warn" (click)="record()">
                <mat-icon>stop</mat-icon>
              </button>
            } @else {
              <button app-icon-button (click)="record()">
                <mat-icon>videocam</mat-icon>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
